




























































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { mapActions, mapMutations, mapState } from "vuex";
import { Message } from "@/interfaces/alert";
import { sendingStatus } from "@/interfaces/status";
import { GlobalMixin } from "@/mixins/global";

@Component({
  metaInfo() {
    return {
      title: "Mos - Contact"
    };
  },
  components: {},
  computed: {
    ...mapState("status", ["sendStatus"])
  },
  methods: {
    ...mapMutations("alert", ["setMessage"]),
    ...mapMutations("status", ["setSend"]),
    ...mapActions("status", ["sendMessage"])
  }
})
export default class Contact extends Mixins(GlobalMixin) {
  form = false;
  subject = "";
  email = "";
  name = "";
  text = "";
  setMessage!: (data: Message) => void;
  sendMessage!: (message: {}) => void;
  setSend!: (send: boolean) => void;

  @Watch("sendStatus") onChange(val: sendingStatus) {
    if (val && val.type === "message") {
      this.setMessage({
        text: "Message sent",
        color: "success",
        icon: "mdi-check"
      });
    }
    this.setSend(false);
  }

  get MarginTop(): object {
    if (this.$vuetify.breakpoint.xl) return { "margin-top": "calc(100vh/7)" };
    else if (this.$vuetify.breakpoint.lg)
      return { "margin-top": "calc(100vh/16)" };
    else if (this.$vuetify.breakpoint.md)
      return { "margin-top": "calc(100vh/8)" };
    else return { "margin-top": "calc(100vh/20)" };
  }

  send(): void {
    if (!this.form) {
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.validate();
    } else {
      const content = this.name + " Says: " + this.text;
      this.sendMessage({
        name: this.subject,
        content: content,
        // eslint-disable-next-line @typescript-eslint/camelcase
        custom_fields: [
          {
            id: "decb4a8a-6120-46b0-9cbb-66f3ee1de3c5",
            value: this.email
          }
        ]
      });
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.reset();
      this.setMessage({ text: "Sending Message", color: "accent" });
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.resetValidation();
    }
  }
}
